(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/joker/joker-price.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/joker/joker-price.js');

'use strict';

svs.numbergames.game.views.JokerPrice = Marionette.View.extend({
  className: 'numbergames-footer-section',
  regions: {
    jokerInfoRegion: '#jokerInfoRegion'
  },
  ui: {
    priceRadio: '.js-joker-price-radio',
    jokerInfo: '.js-joker-info'
  },
  triggers: {
    'change @ui.priceRadio': 'changeJokerPrice',
    'click @ui.jokerInfo': 'clickedJokerInfo'
  },
  modelEvents: {
    'change:isSubscription': 'render',
    'change:jokerPrice': 'onUpdateDOMSelection'
  },
  template(data) {
    return svs.numbergames.game.templates.joker_price(data);
  },
  templateContext() {
    const viewOptions = svs.numbergames.game.view_options[this.model.get('productId')];
    const jokerPrices = svs.numbergames.rules.joker.getJokerPrices();
    return {
      jokerPrices: jokerPrices.map(price => ({
        price
      })),
      isJokerOpen: svs.numbergames.game.draw.isJokerOpen,
      showJokerInfo: typeof (viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.jokerInfoDialog) === 'function'
    };
  },
  onRender() {
    this.showChildView('jokerInfoRegion', {
      model: this.model,
      modelEvents: {
        'change:hasJoker change:isSyndicate': 'render'
      },
      className: 'numbergames-footer-section-info-text',
      template(data) {
        var _svs$numbergames$game;
        const jokerInfoTemplate = (_svs$numbergames$game = svs.numbergames.game.view_options[data.productId]) === null || _svs$numbergames$game === void 0 ? void 0 : _svs$numbergames$game.jokerInfoTemplate;
        const jokerInfoText = jokerInfoTemplate && jokerInfoTemplate(data);
        if (jokerInfoText) {
          return "<p>".concat(jokerInfoText, "</p>");
        }
        return '';
      }
    });
  },
  onChangeJokerPrice(view, event) {
    this.model.set({
      jokerPrice: parseInt(event.target.value, 10)
    });
  },
  onUpdateDOMSelection() {
    this.getUI('priceRadio').each((i, el) => {
      el.checked = parseInt(el.value, 10) === this.model.get('jokerPrice');
    });
  },
  onClickedJokerInfo() {
    var _viewOptions$jokerInf;
    const viewOptions = svs.numbergames.game.view_options[this.model.get('productId')];
    viewOptions === null || viewOptions === void 0 || (_viewOptions$jokerInf = viewOptions.jokerInfoDialog) === null || _viewOptions$jokerInf === void 0 || _viewOptions$jokerInf.call(viewOptions, this.getUI('jokerInfo'));
  }
});

 })(window);